import { render, staticRenderFns } from "./supplierOrders.vue?vue&type=template&id=638494e1&scoped=true"
import script from "./supplierOrders.vue?vue&type=script&lang=js"
export * from "./supplierOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638494e1",
  null
  
)

export default component.exports